const config = {
  siteTitle: "Amin", // Site title.
  siteTitleShort: "Amin", // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: "AminHaeri", // Alternative site title for SEO.
  siteLogo: "", // Logo used for SEO and manifest.
  siteUrl: "https://aminhaeri.com", // Domain of your website without pathPrefix.
  pathPrefix: "", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription:
    "Hi, I am Amin Haeri.", // Website description used for RSS feeds/meta description tag.
  siteRss: "/rss.xml", // Path to the RSS file.
  siteFBAppID: "1825356251115265", // FB Application ID for using app insights
  googleAnalyticsID: "UA-195353091-1", // GA tracking ID.
  disqusShortname: "", // Disqus shortname.
  postDefaultCategoryID: "Tech", // Default category for posts.
  dateFromFormat: "YYYY-MM-DD", // Date format used in the frontmatter.
  dateFormat: "DD/MM/YYYY", // Date format for display.
  userName: "aminhaeri", // Username to display in the author segment.
  userEmail: "me@aminhaeri.com", // Email used for RSS feed's author segment
  userTwitter: "", // Optionally renders "Follow Me" in the UserInfo segment.
  userLocation: "", // User location to display in the author segment.
  userAvatar: "", // User avatar to display in the author segment.
  userDescription: "", // User description to display in the author segment.
  // Links to social profiles/projects you want to display in the author segment/navigation bar.
  avatar: {
    photo: "https://raw.githubusercontent.com/haeriamin/files/master/cover.png"
  },
  userLinks: [
    {
      label: "github",
      url: "https://github.com/haeriamin"
    },
    {
      label: "linkedin",
      url: "https://www.linkedin.com/in/aminhaeri"
    },
    {
      label: "papers",
      url: "https://scholar.google.com/citations?hl=en&user=t3Vw9dcAAAAJ&view_op=list_works&sortby=pubdate"
    }
  ],
  menuLinks: [
    {
      name: "Bio",
      url: "/"
    },
    // {
    //   name: "Research",
    //   url: "/research"
    // },
    {
      name: "Publications",
      url: "/publications"
    },
  ],
  copyright: "Copyright © {(new Date().getFullYear())}", // Copyright string for the footer of the website and RSS feed.
  themeColor: "#c62828", // Used for setting manifest and progress theme colors.
  backgroundColor: "#e0e0e0" // Used for setting manifest background color.
};

// Validate

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === "/") {
  config.pathPrefix = "";
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, "")}`;
}

// Make sure siteUrl doesn't have an ending forward slash
if (config.siteUrl.substr(-1) === "/")
  config.siteUrl = config.siteUrl.slice(0, -1);

// Make sure siteRss has a starting forward slash
if (config.siteRss && config.siteRss[0] !== "/")
  config.siteRss = `/${config.siteRss}`;

module.exports = config;
